import { homePath } from "@/lib/roles";
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Gamepad2 } from "lucide-react";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    processGoogleSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate(homePath(user.role), { replace: true });
      })
      .catch((err) => {
        console.error("Google auth failed:", err);
        navigate("/login", { replace: true });
      });
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-void" data-testid="auth-callback">
      <div className="text-center">
        <Gamepad2 className="w-12 h-12 text-cyber mx-auto mb-4 animate-glow-pulse" />
        <p className="font-mono text-cyber text-lg tracking-widest animate-pulse">
          AUTHENTICATING...
        </p>
      </div>
    </div>
  );
}
